import styled, { css } from 'styled-components'

export const StyledPreview = styled.div`
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
    @media (max-width: 1160px) {
        grid-template-columns: initial;
    }
    .preview {
        display: grid;
        place-items: center;
    }
    .preview-title {
        color: ${({ theme }) => theme.colors.darkGunMetal};
        font-size: ${({ theme }) => theme.fontSizes.large};
        margin: 19px 0;
        opacity: 0.7;
        text-align: center;
        margin-bottom: 19px;
    }

    .customize {
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .custom-text {
        width: 371px;
        height: 120px;
        background: ${({ theme }) => theme.colors.lotion};
        border: 1px solid ${({ theme }) => theme.colors.taupeGray};
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        color: ${({ theme }) => theme.colors.darkGunMetal};
        opacity: 0.7;
        font-size: ${({ theme }) => theme.fontSizes.normal};
        padding: 14px;
        font-weight: ${({ theme }) => theme.fontWeights.bold};
        font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
        margin: 15px auto;
        margin-bottom: 5px;
        resize: none;
        @media (max-width: 760px) {
            width: 271px;
            height: 120px;
        }
    }

    .char-remaining {
        font-size: ${({ theme }) => theme.fontSizes.small};
        color: ${({ theme }) => theme.colors.taupeGray};
        padding-bottom: 2em;
    }

    .divider {
        border: 1px solid ${({ theme }) => theme.colors.dividerGrey};
        margin: 2rem;
        height: 0;
    }
    .form-control {
        display: grid;
        grid-template-columns: 115px 1fr;
        margin-bottom: 30px;
        @media (max-width: 760px) {
            grid-column-gap: 10px;
            grid-template-columns: 95px 1fr;
        }
    }
    .form-label {
        color: ${({ theme }) => theme.colors.darkGunMetal};
        opacity: 0.7;
        font-size: ${({ theme }) => theme.fontSizes.normal};
        font-weight: ${({ theme }) => theme.fontWeights.bold};
        @media (max-width: 760px) {
            font-size: ${({ theme }) => theme.fontSizes.small};
        }
    }
    .share-icon {
        margin-right: 5px;
    }
    .form-social {
        margin: 0 auto 10px auto;
    }
    .image-slider {
        width: 200px;
    }
    .form-action {
        display: flex;
        justify-content: right;
        height: 50px;
        gap: 2rem;
        margin: 0 auto;
    }
    .download-button {
        background: ${({ theme }) => theme.colors.testimony};
        border-radius: 6px;
        color: ${({ theme }) => theme.colors.white};
        font-size: ${({ theme }) => theme.fontSizes.normal};
        border: none;
        padding: 15px 25px;
        text-transform: uppercase;
        cursor: pointer;

        &:disabled {
            background: ${({ theme }) => theme.colors.dividerGrey};
            cursor: not-allowed;
        }
    }
    .share-button {
        background: ${({ theme }) => theme.colors.charlestonGreen};
        border-radius: 5px;
        padding: 15px 11px;
        color: ${({ theme }) => theme.colors.white};
        border: none;
        margin-left: 10px;
        text-transform: uppercase;
        cursor: pointer;
    }
    .dropzone {
        text-align: center;
        padding: 20px;
        border: 3px dashed #eeeeee;
        background-color: #fafafa;
        color: ${({ theme }) => theme.colors.darkGunMetal};
        margin-bottom: 20px;
        font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
    }

    .accept {
        border-color: ${({ theme }) => theme.colors.testimony} !important;
    }

    .reject {
        border-color: ${({ theme }) => theme.colors.red} !important;
    }
`

export const StyledPreviewImage = styled.div`
    ${(props) =>
        css`
            background: url(${props.image});
        `}
    background-size: cover;
    background-repeat: no-repeat;
    width:100%;
    height: 800px;
    position: relative;
    @media (min-width: 320px) and (max-width: 759px) {
        max-width:100%;
        height: 335px;
    }
    .preview-image-container {
        border-radius: 50%;
        position: absolute;
        // START: change this base on the image
        width: 190px;
        height: 190px;
        left: 56px;
        top: 364px;
        // END: change this base on the image
        overflow: hidden;
        @media (min-width: 320px) and (max-width: 759px) {
            // START: change this base on the image
            width: 107px;
            height: 107px;
            left: 27px;
            top: 191px;
            // END: change this base on the image
        }
    }
    .preview-image {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .preview-text {
        color: ${({ theme }) => theme.colors.black};
        position: absolute;
        top: 355px; // change this base on the image
        left: 240px; // change this base on the image
        width: 450px;
        font-size: ${({ theme }) => theme.fontSizes.large};
        font-weight:  ${({ theme }) => theme.fontWeights.bolder};
        line-height: 24px;
        text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
        @media (min-width: 320px) and (max-width: 759px) {
            top: 150px; // change this base on the image
            left: 100px; // change this base on the image
            width: 200px;
            font-size: 9px;
            line-height: 1.3;
        }
    }
    a.preview-hidden {
        display: none;
    }
`
